import React from 'react'

const AbtWhyUs = () => {
  return (
    <>
     <section className="why_us pt-130">
            <div className="container">
                <div className="row align-items-center">
                    <div className="col-lg-6">
                        <div className="why_us-image">
                            <img src="assets/img/about/abt-heroo.webp" alt=""/>
                        </div>
                    </div>
                    <div className="col-lg-6">
                        <div className="section-title mb-30">
                            <span className="sub-title wow fadeInRight" data-wow-duration=".7s">WHY US</span>
                            <h3 className="title xb-split-text split-in-right mb-20">Discover Our <br/> <span>Capabilities</span></h3>
                            <p>Bridging businesses with their audiences, and empowering individuals to achieve their aspirations. Our path forward is one of continuous growth and innovation.</p>
                        </div>
                        <div className="xb-experience ul_li_center ">
                            <div className="xb-item--experience_box xbc25 mt-15">
                                <span className="xb-item--title">Digital<br/>Marketing</span>
                                <div className="xb-item--persantage_box">
                                    <img src="assets/img/about/om-digital-marketing-about-us.webp" alt=""/>
                                    <h5 className="xb-item--persantage">25%</h5>
                                </div>
                            </div>
                            <div className="xb-item--experience_box mt-15 xbc25">
                                <span className="xb-item--title">Web<br/>Development</span>
                                <div className="xb-item--persantage_box">
                                    <img src="assets/img/about/om-web-dev.webp" alt=""/>
                                    <h5 className="xb-item--persantage">25%</h5>
                                </div>
                            </div>
                            <div className="xb-item--experience_box mt-15 xbc50">
                                <span className="xb-item--title">Social Media Management</span>
                                <div className="xb-item--persantage_box">
                                    <img src="assets/img/about/om-smm.webp" alt=""/>
                                    <h5 className="xb-item--persantage">50%</h5>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </>
  )
}

export default AbtWhyUs
